(ns measure.report-builder.view.schedule-report-modal
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            ["react-hook-form" :as rhf]
            [cljs-bean.core :refer [->clj]]
            [common.form :as form]
            [common.modal.view :refer [defmodal modal-v2]]
            [common.widgets.form-field :refer [form-field]]
            [measure.report-builder.context :refer [use-schedule-report-form]]
            [measure.report-builder.core :as rbc]
            [measure.report-builder.hooks :as h]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$]]))

(defmodal schedule-report :report/schedule
  [{:keys [report]}]
  (let [{{:keys [control]} :form-control
         :keys [on-submit]} (use-schedule-report-form {:report report})
        form-values (->clj (rhf/useWatch #js {:control control}))

        generated-name (uix/use-memo
                        (fn []
                          (rbc/generate-report-name form-values :report-schedule))
                        [form-values])]
    ($ :form {:onSubmit on-submit}
       ($ modal-v2
          {:title "Schedule report"
           :footer ($ Stack {:direction "row" :gap 1}
                      ($ Button {:variant "text"
                                 :onClick #(rf/dispatch [:modal/close])
                                 :sx #js {:color "text.primary"}}
                         "Cancel")
                      ($ Button {:variant "contained"
                                 :type "submit"}
                         "Create schedule"))}
          ($ Stack
             {:gap 2
              :sx #js {:minWidth 400}}
             ($ form-field
                {:label "Date range"
                 :required true}
                ($ form/autocomplete-field
                   {:name "date-phrase"
                    :control control
                    :field-props {:options h/date-phrase-options}}))
             ($ form-field
                {:label "Schedule interval"}
                ($ form/radio-group
                   {:name "schedule"
                    :control control
                    :field-props {:options h/schedule-options}}))
             ($ form-field
                {:label "Schedule name"}
                ($ form/form-text-field
                   {:name "name"
                    :control control
                    :field-props {:placeholder generated-name}})))))))
